import React from 'react';

const Marquee = () => {
    return (
        <section className="is-fullwidth is-stretched" data-padding="none">
            <div className="infocolors-marquee" data-speed="5000">
                <div className="infocolors-marquee-inner">
                    <ul className="infocolors-marquee-list">
                        <li>
                            <h2>Unleash Your Creativity</h2>
                        </li>
                        <li>
                            <h2>Spark Imagination</h2>
                        </li>
                        <li>
                            <h2>Creative Firestorms</h2>
                        </li> 
                        <li>
                            <h2>Ignite Results</h2>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default Marquee;
